/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_StudentInputs */

const en_form_student = /** @type {(inputs: Form_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const he_form_student = /** @type {(inputs: Form_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמיד`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Form_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_student = /** @type {((inputs?: Form_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_student(inputs)
	return he_form_student(inputs)
});